import {
    getDateFromYmd,
    useBookingPageContext,
} from 'context/bookingContext/BookingPageContainer'
import React, { useEffect } from 'react'
import { ServiceApiTypeEnum } from 'types/service'
import { ONE_DAY_IN_MS } from 'utils/scheduling-helper'
import { isPreviousDate, toYmd } from 'utils/string-localization-helper'
import DayTabs, { DayTabMode } from '../DayTabs'
import Cookies from 'js-cookie'
import { convertToAccountTimeZone } from 'utils/date-and-time-helper'

type DayTabsContainerProps = {
    mode: DayTabMode
    type_override?: ServiceApiTypeEnum
    hide_bar?: boolean
}

function DayTabsContainer(props: DayTabsContainerProps) {
    const { activeDate, fromDate, setFromDate, toDate, setToDate, router } =
        useBookingPageContext()
    const timezone = Cookies.get('timezone') || 'America/New_York'

    useEffect(() => {
        const day = router?.query?.d as string

        if (!day) return

        const param_date = new Date(getDateFromYmd(day))

        const current_date =
            convertToAccountTimeZone(timezone, new Date()) || new Date()

        // const current_date = new Date()

        let from_date = new Date(current_date)

        if (isPreviousDate(param_date, current_date)) {
            from_date.setDate(current_date.getDate() + 1)
            setFromDate(current_date)
            router.push({ query: { ...router.query, d: toYmd(from_date) } })
        } else {
            if (
                isPreviousDate(param_date, fromDate) ||
                isPreviousDate(toDate, param_date)
            ) {
                from_date = param_date
                setFromDate(new Date(current_date))
                setToDate(
                    new Date(
                        new Date().setTime(
                            from_date.getTime() + ONE_DAY_IN_MS * 8
                        )
                    )
                )
                router.push({
                    query: { ...router.query, d: toYmd(from_date) },
                })
            }
        }
    }, [router?.query.d])

    const addOneMoreDay = (e: any) => {
        let new_dt = new Date(toDate?.getTime())
        new_dt.setDate(toDate?.getDate() + 1)
        setToDate(new_dt)

        new_dt = new Date(fromDate.getTime())
        new_dt.setDate(fromDate.getDate() + 1)
        setFromDate(new_dt)
    }

    const revertPreviousDay = (e: any) => {
        let new_dt = new Date(toDate.getTime())
        new_dt.setDate(toDate.getDate() - 1)
        setToDate(new_dt)

        new_dt = new Date(fromDate.getTime())
        new_dt.setDate(fromDate.getDate() - 1)
        setFromDate(new_dt)
    }

    return (
        <div>
            <DayTabs
                active_date={activeDate as Date}
                dt_from={fromDate as Date}
                dt_to={toDate as Date}
                mode={props.mode}
                type_override={props.type_override}
                addOneMoreDay={addOneMoreDay}
                revertPreviousDay={revertPreviousDay}
                hide_bar={props.hide_bar}
            />
        </div>
    )
}

export default DayTabsContainer
